__turbopack_context__.v({
  "chart": "eNaGVG_chart",
  "chart-wrapper": "eNaGVG_chart-wrapper",
  "dip": "eNaGVG_dip",
  "peak": "eNaGVG_peak",
  "price": "eNaGVG_price",
  "time": "eNaGVG_time",
});
